import { endpoints } from 'Constants';

const commentsServices = {
	getComment: (params) => {
		return {
			baseURL: endpoints.BUSINESS.COMMENTIFY(),
			method: 'GET',
			params: params,
		};
	},

	reply: (params) => ({
		baseURL: endpoints.COMMENTIFY.REPLY(params?.id),
		method: 'POST',
		data: params?.body,
	}),
};

export default commentsServices;
